import React, { useState, useRef, } from 'react';

import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';

const AdForm = (props) => {

    const [saving, setSaving] = useState(false)
    const [isFormShow, setIsFormShow] = useState(false);
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');

    const accordionBtn = useRef();

    const handleShowForm = () => {
        setIsFormShow(!isFormShow);
        setTitle('');
        setUrl('');
    }

    const hideForm = () => {
        if (isFormShow) accordionBtn.current.click();
    }

    const invalid = title === '' || url === '';

    const onSubmit = (e) => {
        e.preventDefault();
        if (!invalid && !saving) {
            setSaving(true);
            props.firebase.adsCollection().add({
                createdAt: props.firebase.timestamp(),
                title: title,
                url: url
            })
                .then((result) => {
                    setSaving(false);
                    hideForm();
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setSaving(false);
                    props.showModal("Error", "No se pudo añadir la publicidad");
                });
        }
    }

    const textButtom = isFormShow ? 'Ocultar' : 'Añadir Publicidad';
    const iconButton = isFormShow ? faAngleUp : faAngleDown;

    return (
        <div className="bg-white border rounded-lg accordion p-2" id="accordionOfferForm">
            <div className="nav justify-content-between align-items-center">
                <h6 className="font-weight-bolder m-0">Publicidad</h6>

                <button ref={accordionBtn} onClick={handleShowForm} className="btn btn-second btn-sm" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                    <span className="mr-2 d-none d-md-inline">{textButtom}</span>
                    <FontAwesomeIcon className="" icon={iconButton} />
                </button>
            </div>
            <div id="offerFormCollapse" className="collapse hide" data-parent="#accordionOfferForm">
                <div className=" pl-2 pr-2">
                    {/* <span className="font-weight-bolder ml-2">Añadir Usuario</span> */}

                    <form onSubmit={onSubmit}>
                        <div className="row m-0">
                            <div className="col row pl-0 pr-0 m-0">
                                <div className="col col-12 col-sm-3 p-2">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="title">Título:</label>
                                    <input className="form-control form-control-sm" value={title} type="text" onChange={(e) => setTitle(e.target.value)} id="title" name="title" placeholder="..." />
                                </div>
                                <div className="col col-12 col-sm-9 p-2">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="url">Enlace:</label>
                                    <input className="form-control form-control-sm" value={url} type="url" onChange={(e) => setUrl(e.target.value)} id="url" name="url" placeholder="https://example.com" />
                                </div>
                            </div>

                            {(!saving) ?
                                <div className="col-12 row pl-0 pr-0 m-0 justify-content-end">
                                    <button disabled={invalid} type="submit" className="btn btn-sm btn-success m-2">Guardar</button>
                                </div>
                                :
                                <div className="col-12 row nav justify-content-end m-0 p-0">
                                    <Loader className="m-2"
                                        type="ThreeDots"
                                        color="#263238"
                                        height={30}
                                        width={50}
                                        timeout={0} />
                                </div>
                            }
                        </div>

                    </form>
                </div>
            </div>
        </div >
    )

}

export default withFirebase(AdForm);
